import 'arrayq';
import { PureConnect, React } from '../../react';
import Input from 'react-toolbox/lib/input';
import { INote, IParticipant, IQuestionDB, IUsergroup, isQuestion, isSharedNote } from '../../types';
import { notesEditor } from '../notes/resource';
import cx from './style.less';
import authSelectors from '../../auth/selectors';
import selectorsParticipantPopup from '../noteParticipantSelectPopup/selectors';
import selectorsCategoryPopup from '../categorySelectPopup/selectors';
import selectorsQuestion from '../question/selectors';
import { selectors as metaSelectors } from '../../meta/selectors';
import { participantsResource } from '../../participant/resource';
import UPDATE_BUTTON_NO from '../../focuslock/actions/UPDATE_BUTTON_NO';
import windowSelectors from '../../window/selectors';
import notesSelector from '../notes/selectors';
import selectorQuestion from '../question/selectors';
import { usergroupResource } from '../../usergroup/resource';
import { Btn } from '../../react-toolbox-redesign/button';
import { DateTimeText } from '../../shared/date';
import { hack } from '../../browser/launch';
import { notechatEditor } from '../notechat/resource';
import { questionsEditor, questionsResource } from '../question/resource';
import OPEN_DROPDOWN_STATUS from '../question/action/OPEN_DROPDOWN_STATUS';
import { canAnswer, practicioners, showAnswer, showPracticioner, statusses, statussesallowed } from './authmodule/authcheck';
import { useridResource } from '../../participantid/resource';
import DropDownBasic, { DropDownItemBasic } from '../../react-toolbox-extended/dropdownbasic';
import QUESTION_LINK from './action/QUESTION_LINK';
const maxNoteTextLength = 3000;
const minLinesVisible = 3;
const maxLinesVisible = 75;
import selectorsLinking from '../question/selectors';
import QUESTION_SAVE from './action/QUESTION_SAVE';
import QUESTION_SHOWLINKS from './action/QUESTION_SHOWLINKS';
import MAXIMIZED from './action/QUESTION_MAXIMIZE';
import questionSelector from './selectors';
import OPEN_DROPDOWN_PRACTICIONER from './action/OPEN_DROPDOWN_PRACTICIONER';

export const FlyoverQuestionEditLayout = PureConnect(`FlyoverQuestionEditLayout`)(
    (state) => ({
        creating: notesEditor.selectors.creating(state),
        item: notesEditor.selectors.item(state),
        itemQuestionDB: questionsEditor.selectors.item(state),
        itemQuestion: selectorQuestion.questionItemSelector(state),
        updating: notesEditor.selectors.updating(state),
        updatingNoteChat: notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: authSelectors.user(state),
        usergroups: usergroupResource.selectors.items(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        currentUser: useridResource.selectors.items(state),
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        dropdownStatusOpen: selectorsQuestion.open(state), 
        dropdownopenPracticioner: selectorsQuestion.opendropdownPracticioner(state), 
        selectTextArea: state.selection.creating,
        screenSmall: windowSelectors.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible,
    }),
    (dispatch) => ({
        change: (item: INote | any) => { dispatch(notesEditor.actions.APPLY({ item })); },
        changeQuestion: (item: IQuestionDB | any) => dispatch(questionsEditor.actions.APPLY({ item })),          
        updateButtonFocus: (buttonNr: number, origin: number, itm: INote) => {
            dispatch(UPDATE_BUTTON_NO({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        showDropdownStatus: (dropdownStatusOpen: boolean) => dispatch(OPEN_DROPDOWN_STATUS({dropdownopen:dropdownStatusOpen})),
    }),
    ({ flyoverVisible, creating, updating, updatingNoteChat, selectNote, item, itemQuestionDB, itemQuestion, initialized, change, participantPopupVisible, categoryPopupVisible, selectTextArea, changeQuestion, showDropdownStatus, dropdownStatusOpen, dropdownopenPracticioner, usergroups, currentUser, allparticipants}) => {
        const isquestion = isQuestion(item);
        var visible = flyoverVisible && (creating || updating) && isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
        var maxlines = maxLinesVisible;
        var selection = document.querySelector('.text-container textarea');
        if (visible && selection && initialized) {
            maxlines = countLines(selection, maxlines);
        }
        var currentUserid =  currentUser.length > 0 ?  currentUser[0].id : '';

        const statusitems=statussesallowed(statusses, itemQuestionDB.status, currentUserid, usergroups ).map((status) => {
            var dropDownItem: DropDownItemBasic = {
                key:status.id,        
                name:status.name.toUpperCase(),
                statusclass: 'status-' + status.id.toString(),    
                prefix: 'status-', 
            };
            return dropDownItem;
        }); 

        var StatusSelectie = <DropDownBasic
            title={'Status'}
            value={itemQuestionDB.status}
            items={statusitems}
            prefix={'status-'}
            extraclass={'status-class'}
            toggleDropDown={(key: number)=> {showDropdownStatus( !dropdownStatusOpen);}}
            itemSelection={(key: number) => { itemQuestionDB.status=key; changeQuestion( itemQuestionDB ); }}
        ></DropDownBasic>;

        var practicionersitems = 
        [{
            key: -1,        
            name: 'Kies...',
            statusclass: 'practicioner-',    
            prefix: 'practicioner-', 
        } as DropDownItemBasic].concat(
            practicioners( allparticipants, usergroups ).map((practicioner) => {
            var dropDownItem: DropDownItemBasic = {
                key: practicioner.key,        
                name: practicioner.name,
                statusclass: 'practicioner-' + practicioner.id,    
                prefix: 'practicioner-', 
            };
            return dropDownItem;
        }));

        var BehandelaarSelectie = <DropDownBasic
            title={'Behandelaar'}
            value={allparticipants && allparticipants.qFirst((us: IParticipant) => us.id===itemQuestionDB.practicionerId) ? allparticipants.qFirst((us: IParticipant) => us.id===itemQuestionDB.practicionerId).key: -1}
            items={practicionersitems}
            prefix={'practicioner-'}
            extraclass={cx('practicioner-class')}
            toggleDropDown={(key: number)=> {showDropdownStatus( !dropdownopenPracticioner);}}
            itemSelection={(key: number) => { 
                var practicionerId = allparticipants && allparticipants.qFirst((us) => us.key===key) && allparticipants.qFirst((us) => us.key===key).id;
                if (practicionerId) {
                    itemQuestionDB.practicionerId=practicionerId; 
                    changeQuestion( itemQuestionDB ); } else {
                    itemQuestionDB.practicionerId=undefined; 
                    changeQuestion( itemQuestionDB );
                }
            }}
        ></DropDownBasic>;
     
        var input = <Input
            disabled={!!isSharedNote(item)}
            type="text"
            name="note"
            rows={maxlines}
            value={item.text}
            maxLength={maxNoteTextLength}
            multiline
            className={'text-container'}
            onChange={(value: string) => change({ text: value })}
            floating />;

        var inputAntwoordConcern = <Input
            disabled={!canAnswer(statusses, itemQuestionDB.status, currentUserid, usergroups )}
            type="text"
            name="antwoordConcern"
            rows={maxlines}
            value={itemQuestionDB.antwoordConcern ? itemQuestionDB.antwoordConcern : ''}
            maxLength={maxNoteTextLength}
            multiline
            className={'text-container'}
            onChange={(valueAntwoord: string) => changeQuestion({ antwoordConcern: valueAntwoord })}
            floating />;              

        return (
            <div className={cx('create_note', (!visible) ? 'wcag-invisible' : '', 'fields-container')}
                aria-hidden={!(visible)}
                aria-labelledby="Stel een vraag">
                <title>
                    <span className={cx('title-icon')} data-icon={'icon_comment-question'}></span>
                    <span className={cx('title-text')}>{'TECHNISCHE VRAAG'}</span>
                </title>
                <div className={cx('note-container')}>
                    <div className={cx('question-status-container') + ' question-status-container'}>
                        <div className={cx('text-created-container-bottom')}>{StatusSelectie}</div>
                    </div>
                    <div className={cx('question-practicioner-container', !showPracticioner(itemQuestionDB.status, currentUserid, usergroups) ? 'wcag-invisible' : '') + ' question-practicioner-container'}>
                            <div className={cx('text-created-container-bottom')}>{BehandelaarSelectie}</div>
                    </div>
                    <span className={cx('sub-title')}>Uw vraag test<span className={cx('important-icon')}>*</span></span>
                    <div id="note" className={cx('input-text-notitie',
                        (item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : ''), (flyoverVisible ? 'flyover' : ''))}>
                        {input}
                    </div>
                    <div className={cx('answer-container', 'edit-question-container', (!showAnswer(itemQuestionDB.status, currentUserid, usergroups)) ? 'wcag-invisible' : '')}>
                        <span className={cx('sub-title')}>Antwoord vanuit Concern<span className={cx('important-icon')}>*</span></span>
                        <div id="note" className={cx('input-answer-container',
                            (item && itemQuestionDB.antwoordConcern && itemQuestionDB.antwoordConcern.length >= maxNoteTextLength ? 'alert-max-chars' : ''))}>
                            {inputAntwoordConcern}
                        </div>
                    </div>  
                </div>
            </div>
        );
    });    

export const ModalQuestionEditLayout = PureConnect(`ModalQuestionEditLayout`)(
    (state) => ({
        creating: notesEditor.selectors.creating(state),
        item: notesEditor.selectors.item(state),
        itemQuestionDB: questionsEditor.selectors.item(state),
        updating: notesEditor.selectors.updating(state),
        updatingNoteChat: notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: authSelectors.user(state),
        usergroups: usergroupResource.selectors.items(state),
        currentUser: useridResource.selectors.items(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        dropdownStatusOpen: selectorsQuestion.open(state), 
        dropdownopenPracticioner: selectorsQuestion.opendropdownPracticioner(state),         
        selectTextArea: state.selection.creating,
        screenSmall: windowSelectors.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible,
        allQuestions: questionsResource.selectors.items(state),
        linking: selectorsLinking.linking(state),
        showlinks: selectorsLinking.showlinks(state),
        ismaximized: questionSelector.ismaximized(state),
    }),
    (dispatch) => ({
        change: (item: INote | any) => { dispatch(notesEditor.actions.APPLY({ item })); },
        changeQuestion: (item: IQuestionDB | any) => dispatch(questionsEditor.actions.APPLY({ item })),        
        updateButtonFocus: (buttonNr: number, origin: number, itm: INote) => {
            dispatch(UPDATE_BUTTON_NO({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        showDropdownStatus: (dropdownStatusOpen: boolean) => dispatch(OPEN_DROPDOWN_STATUS({dropdownopen:dropdownStatusOpen})),
        showDropdownPracticioner: (dropdownopenPracticioner: boolean) => dispatch(OPEN_DROPDOWN_PRACTICIONER({dropdownopenPracticioner:dropdownopenPracticioner})),
        koppel: (item: IQuestionDB) => {
            dispatch(QUESTION_LINK({linkvisible: true, linkitem: item }));
        },     
        toonlinks: (item: IQuestionDB) => {
            dispatch(QUESTION_SHOWLINKS({showlinks: true, showitem: item}));
        },          
        maximize: (maximized: boolean) => dispatch(MAXIMIZED({ maximized: maximized })),
    }),
    ({ creating, updating, updatingNoteChat, allQuestions, flyoverVisible, selectNote, item, itemQuestionDB, user, usergroups, currentUser, initialized, change, allparticipants, participantPopupVisible, categoryPopupVisible, 
                selectTextArea, changeQuestion, showDropdownStatus, dropdownStatusOpen, dropdownopenPracticioner,
                koppel, linking, toonlinks, showlinks, ismaximized, maximize}) => {

        var koppelen = item && itemQuestionDB && item.id === itemQuestionDB.noteId && !itemQuestionDB.parentId;
        var ontkoppelen = item && itemQuestionDB && item.id === itemQuestionDB.noteId && !!itemQuestionDB.parentId;

        const isquestion = isQuestion(item);
        var visible = !flyoverVisible && (creating || updating) && isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea && !linking && !showlinks;

        var maxlines = maxLinesVisible;
        var selection = document.querySelector('.text-container textarea');
        if (visible && selection && initialized) {
            maxlines = countLines(selection, maxlines);
        }        

        var currentUserid =  currentUser.length > 0 ?  currentUser[0].id : '';
        const statusitems=statussesallowed(statusses, itemQuestionDB.status, currentUserid, usergroups ).map((status) => {
            var dropDownItem: DropDownItemBasic = {
                key:status.id,        
                name:status.name.toUpperCase(),
                statusclass: 'status-' + status.id.toString(),    
                prefix: 'status-', 
            };
            return dropDownItem;
        }); 

        var StatusSelectie = <DropDownBasic
            title={'Status'}
            value={itemQuestionDB.status}
            items={statusitems}
            prefix={'status-'}
            extraclass={'status-class'}
            toggleDropDown={(key: number)=> {showDropdownStatus( !dropdownStatusOpen);}}
            itemSelection={(key: number) => { itemQuestionDB.status=key; changeQuestion( itemQuestionDB ); }}
        ></DropDownBasic>;

        var practicionersitems = 
        [{
            key: -1,        
            name: 'Kies...',
            statusclass: 'practicioner-',    
            prefix: 'practicioner-', 
        } as DropDownItemBasic].concat(
            practicioners( allparticipants, usergroups ).map((practicioner) => {
            var dropDownItem: DropDownItemBasic = {
                key: practicioner.key,        
                name: practicioner.name,
                statusclass: 'practicioner-' + practicioner.id,    
                prefix: 'practicioner-', 
            };
            return dropDownItem;
        }));

        var BehandelaarSelectie = <DropDownBasic
            title={'Behandelaar'}
            value={allparticipants && allparticipants.qFirst((us: IParticipant) => us.id===itemQuestionDB.practicionerId) ? allparticipants.qFirst((us: IParticipant) => us.id===itemQuestionDB.practicionerId).key: -1}
            items={practicionersitems}
            prefix={'practicioner-'}
            extraclass={cx('practicioner-class')}
            toggleDropDown={(key: number)=> {showDropdownStatus( !dropdownopenPracticioner);}}
            itemSelection={(key: number) => { 
                var practicionerId = allparticipants && allparticipants.qFirst((us) => us.key===key) && allparticipants.qFirst((us) => us.key===key).id;
                if (practicionerId) {
                    itemQuestionDB.practicionerId=practicionerId; 
                    changeQuestion( itemQuestionDB ); } else {
                    itemQuestionDB.practicionerId=undefined; 
                    changeQuestion( itemQuestionDB );
                }
            }}
        ></DropDownBasic>;

        var input = <Input
            disabled={!!isSharedNote(item)}
            type="text"
            name="note"
            rows={maxlines}
            value={item.text}
            maxLength={maxNoteTextLength}
            multiline
            className={'text-container'}
            onChange={(value: string) => change({ text: value })}
            floating />;

        var inputAntwoordConcern = <Input
            disabled={!canAnswer(statusses, itemQuestionDB.status, currentUserid, usergroups )}
            type="text"
            name="antwoordConcern"
            rows={maxlines}
            value={itemQuestionDB.antwoordConcern ? itemQuestionDB.antwoordConcern : ''}
            maxLength={maxNoteTextLength}
            multiline
            className={'text-container'}
            onChange={(valueAntwoord: string) => changeQuestion({ antwoordConcern: valueAntwoord })}
            floating />;     

        var haschildren = false; 
        var amountofchildren = 0;     
        if (allQuestions) {
            const itemQuestion = allQuestions.qFirst((o: IQuestionDB) => o.noteId === item.id) as IQuestionDB;
            if (itemQuestion) {                
                haschildren = allQuestions.qWhere((x: IQuestionDB)=>!!x.parentId).map((d: IQuestionDB) =>d.parentId).qAny((c: number) => c === itemQuestion.noteId);
                amountofchildren = allQuestions.qWhere((x: IQuestionDB)=>!!x.parentId && x.parentId === itemQuestion.noteId).length;
            }
        }

        return (
            <div className={cx('create_note', 'details', (!visible) ? 'wcag-invisible' : '', 'fields-container')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een technische vraag aan">
                <div>
                    <span className={cx('expand_button-container')}> 
                        <button type="button" className={cx('btn', 'icon-btn', !ismaximized ? 'expand' : 'collapse')} onClick={()=> {maximize( !ismaximized );}}>
                            <span className={cx('arrow-expand-icon')}></span>
                        </button>
                    </span>
                </div>
                <section role="content-info" className={cx('content-container')}>
                    <div className={cx('details-top-container')}>
                        <div className={cx('details-title-container')}>
                            <span className={cx('title-text-action')}>{'Technische vraag wijzigen'}</span>
                            <div className={cx('icon-left-container')}>
                                <span className={cx('icon-container','question' )} ></span>
                            </div>
                            <div className={cx('text-created-container')}>
                                <div className={cx('text-created-container-top')}>{'TECHNISCHE VRAAG'}</div>
                                <div className={cx('text-created-container-bottom')}><DateTimeText date={item.created} /></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={cx('details-content-container', !ismaximized ? '' : 'maximized')}>
                    {isquestion && !haschildren ?
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Koppelen'}
                            aria-haspopup={false}
                            tabIndex={0}
                            disabled={false}
                            onKeyDown={(evt: any) => { handleEnters(evt, koppelen ? 
                                                        () => koppel(itemQuestionDB) : 
                                                        () => {itemQuestionDB.parentId=undefined; return changeQuestion(itemQuestionDB); },
                            );}}
                            onClick={koppelen ? 
                                    () => koppel(itemQuestionDB) : 
                                    () => {itemQuestionDB.parentId=undefined; return changeQuestion(itemQuestionDB); }}
                        >
                            <span>{koppelen ? 'KOPPEL TECHNISCHE VRAAG' : ontkoppelen ? 'ONTKOPPEL TECHNISCHE VRAAG' : '' }</span>
                        </Btn> :
                        isquestion && haschildren && amountofchildren>0 ?
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Toon links'}
                            aria-haspopup={false}
                            tabIndex={0}
                            disabled={false}
                            onKeyDown={(evt: any) => handleEnters(evt, () => toonlinks(itemQuestionDB))}
                            onClick={() => toonlinks(itemQuestionDB)}
                        >
                            <span> BEKIJK GEKOPPELDE VRAGEN ({amountofchildren})</span>
                        </Btn>:                    
                        null
                    }   
                    <div className={cx('middle-container')}>
                        <div className={cx('made-by-container')}>
                            <div className={cx('text-created-container-top')}>Aangemaakt door</div>
                            <div className={cx('text-created-container-bottom')}>{mapParticipantName(item.userId, allparticipants)}</div>
                        </div> 
                        <div className={cx('question-status-container') + ' question-status-container'}>
                            <div className={cx('text-created-container-bottom')}>{StatusSelectie}</div>
                        </div>
                        <div className={cx('question-practicioner-container', !showPracticioner(itemQuestionDB.status, currentUserid, usergroups) ? 'wcag-invisible' : '') + ' question-practicioner-container'}>
                            <div className={cx('text-created-container-bottom')}>{BehandelaarSelectie}</div>
                        </div>
                    </div>                   
                    <div className={cx('note-container', 'edit-note-container')}>
                        <span className={cx('sub-title')}>Uw technische vraag<span className={cx('important-icon')}>*</span></span>
                        <div id="note" className={cx('input-text-notitie',
                            (item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : ''))}>
                            {input}
                        </div>
                    </div>
                    <div className={cx('answer-container', 'edit-question-container', (!showAnswer(itemQuestionDB.status, currentUserid, usergroups)) ? 'wcag-invisible' : '')}>
                        <span className={cx('sub-title')}>Antwoord vanuit Concern<span className={cx('important-icon')}>*</span></span>
                        <div id="note" className={cx('input-answer-container',
                            (item && itemQuestionDB.antwoordConcern && itemQuestionDB.antwoordConcern.length >= maxNoteTextLength ? 'alert-max-chars' : ''))}>
                            {inputAntwoordConcern}
                        </div>
                    </div>                     
                    
                </section>

            </div>

        );
    });

export const QuestionSaveArea = PureConnect(`QuestionSaveArea`)(
(state) => ({
    creating: notesEditor.selectors.creating(state),
    updating: notesEditor.selectors.updating(state),  
    linking: selectorsLinking.linking(state),  
    creatingQuestion: questionsEditor.selectors.creating(state),
    updatingQuestion: questionsEditor.selectors.updating(state),    
    item: notesEditor.selectors.item(state),
    itemQuestionDB: questionsEditor.selectors.item(state), 
    updatingNoteChat: notechatEditor.selectors.updating(state),
    selectNote: state.selection.creating,
    user: authSelectors.user(state),
    allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
    allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
    origin: state.notemenu.origin,
    participantPopupVisible: selectorsParticipantPopup.visible(state),
    categoryPopupVisible: selectorsCategoryPopup.visible(state),
    selectTextArea: state.selection.creating,
    screenSmall: windowSelectors.small(state),
    isminimized: notesSelector.isminimized(state),
    documentId: metaSelectors.docId(state),
    showlinks: selectorsLinking.showlinks(state),
}),
(dispatch) => ({
    cancel: () => { dispatch(notesEditor.actions.RESET({}));
                    dispatch(questionsEditor.actions.RESET({}));},
    cancelCreating: () => {
        dispatch(notesEditor.actions.CREATE_CANCEL({}));
        dispatch(questionsEditor.actions.CREATE_CANCEL({}));
    },
    cancelUpdating: (updatingQuestion: boolean) => {
        dispatch(notesEditor.actions.UPDATE_CANCEL({}));
        if (updatingQuestion) {
            dispatch(questionsEditor.actions.UPDATE_CANCEL({}));
        } else {
            dispatch(questionsEditor.actions.CREATE_CANCEL({}));
        }
    },
    saveCreating: (item: INote, itemQuestionDB: IQuestionDB, documentId: string) => {
        item = fixNoteDevelopmentJsonServer(item, true);    
        dispatch(notesEditor.actions.CREATE_CONTINUE({ item }));
    },
    saveUpdating: (item: INote, itemQuestionDB: IQuestionDB, documentId: string, creatingQuestion: boolean, updatingQuestion: boolean) => {
        item = fixNoteDevelopmentJsonServer(item, false);
        if (!!isSharedNote(item)) {
            dispatch(notesEditor.actions.UPDATE_CANCEL({ item }));
            dispatch(QUESTION_SAVE({saveitem: itemQuestionDB}));
        } else {
            dispatch(notesEditor.actions.UPDATE_CONTINUE({ item }));
        }
    },

}),
({ creating, updating, creatingQuestion, updatingQuestion, updatingNoteChat, selectNote, item, itemQuestionDB, documentId, saveCreating, cancelCreating, saveUpdating, cancelUpdating, participantPopupVisible, categoryPopupVisible, selectTextArea, linking, showlinks }) => {
    var visible = (creating || updating) && item.isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea && !linking && !showlinks;    
    return (
        <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
            aria-hidden={!(visible)}
            aria-labelledby="Maak een notitie aan">
            {/* WCAG (button):
                        1) no role; they are buttons
                        2) focussable (Tab)
                        3) toggle function: n/a (when true use aria-checked)
                        4) aria-expanded: n/a
                        5) aria-haspopup: n/a  
                        6) aria-labelledby/aria-describedby: ref to label
                        7) icon of button is explained by tekst-> aria-hidden*/}
            <div className={cx('bottom-buttons')}>
                <div className={cx('buttons-container', participantPopupVisible || categoryPopupVisible ? 'wcag-invisible' : '')}>
                    <Btn
                        type="button"
                        className={'btn'}
                        extraClassNames={'secondary-btn'}
                        aria-label={'Annuleren'}
                        aria-haspopup={false}
                        tabIndex={0}
                        onKeyDown={(evt: any) => {
                            handleEnters(evt,
                                creating && !updating ?
                                    () => { cancelCreating(); } :
                                    () => { cancelUpdating(updatingQuestion); });
                        }}
                        onClick={creating && !updating ?
                            () => { cancelCreating(); } :
                            () => { cancelUpdating(updatingQuestion); }}
                    >
                        <span>Annuleren</span>
                    </Btn>

                    <Btn
                        type="button"
                        className={'btn'}
                        aria-label={'Opslaan'}
                        aria-haspopup={false}
                        tabIndex={item.text ? 0 : -1}
                        disabled={!item.text}
                        onKeyDown={(evt: any) => {
                            handleEnters(evt, creating && !updating ?
                                () => saveCreating(item, itemQuestionDB, documentId) :
                                () => saveUpdating(item, itemQuestionDB, documentId, creatingQuestion, updatingQuestion));
                        }}
                        onClick={creating && !updating ?
                            () => saveCreating(item, itemQuestionDB, documentId) :
                            () => saveUpdating(item, itemQuestionDB, documentId, updatingQuestion, updatingQuestion)}
                    >
                        <span>Opslaan</span>
                    </Btn>
                </div>

            </div>
        </div>

    );
});

function mapParticipantName(participantId: string, allparticipants: IParticipant[]) {
    const participant = allparticipants.qWhere((item) => participantId === item.id);
    return participant && participant.qAny() ? `${participant[0].name}` : '';
}

function countLines(textarea: any, max: number) {
    var buffer = null;
    if (buffer == null) {
        buffer = document.createElement('textarea');
        buffer.style.border = 'none';
        buffer.style.height = '0';
        buffer.style.overflow = 'hidden';
        buffer.style.padding = '0';
        buffer.style.position = 'absolute';
        buffer.style.left = '0';
        buffer.style.top = '0';
        buffer.style.zIndex = '-1';
        buffer.rows = max;
        document.body.appendChild(buffer);
    }

    var cs = window.getComputedStyle(textarea, '');
    var pl = parseInt(cs.paddingLeft);
    var pr = parseInt(cs.paddingRight);
    var lh = parseInt(cs.lineHeight);

    // [cs.lineHeight] may return 'normal', which means line height = font size.
    if (isNaN(lh)) lh = parseInt(cs.fontSize);

    // Copy content width.
    buffer.style.width = (textarea.clientWidth - pl - pr) + 'px';

    // Copy text properties.
    buffer.style.font = cs.font;
    buffer.style.letterSpacing = cs.letterSpacing;
    buffer.style.whiteSpace = cs.whiteSpace;
    buffer.style.wordBreak = cs.wordBreak;
    buffer.style.wordSpacing = cs.wordSpacing;
    buffer.style.wordWrap = cs.wordWrap;

    // Copy value.
    buffer.value = textarea.value;

    var result = Math.floor(buffer.scrollHeight / lh);

    if (result === 0) result = 1;
    if (result <= minLinesVisible) { 
        return minLinesVisible;
    } else if (result > minLinesVisible && result < maxLinesVisible) { 
        return result + 1;
    } else { 
        return maxLinesVisible; }

    // return result <= minLinesVisible ? minLinesVisible : maxLinesVisible;
}

function fixNoteDevelopmentJsonServer(item: INote, create: boolean) {

    return item;
}

function handleEnters(evt: any, funct: () => void) {
    if (evt.key === 'Enter') { evt.preventDefault(); funct(); }
}   



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/questionEditArea.tsx